var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-footer"},[_c('div',{staticClass:"footer footer-sp-bottom"},[_c('div',{staticClass:"copyright"},[_c('p',[_vm._v("Copyright © "),_c('br',{staticClass:"sp-only"}),_vm._v("fushimi-yoshihiro.com All Rights Reserved.")])])])])
}]

export { render, staticRenderFns }